import React from "react";
import { motion } from "framer-motion";
import { MessageSquareQuote } from "lucide-react";

const bubbleIn = (delay) => ({ initial: { opacity: 0, y: 14, scale: 0.97 }, whileInView: { opacity: 1, y: 0, scale: 1 }, viewport: { once: true }, transition: { delay, duration: 0.45, ease: [0.25, 1, 0.5, 1] } });

export function CustomerReview() {
  return (
    <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-16" data-testid="customer-review">
      <div className="text-center mb-8">
        <p className="text-xs font-bold uppercase tracking-widest text-emerald-700 flex items-center justify-center gap-1.5"><MessageSquareQuote className="w-3.5 h-3.5" /> From a sales team using Pitch Craft</p>
      </div>
      <div className="space-y-4">
        <motion.div {...bubbleIn(0)} className="flex items-end gap-3">
          <div className="w-10 h-10 rounded-full bg-slate-900 text-white flex items-center justify-center text-sm font-bold shrink-0 shadow" aria-hidden>SM</div>
          <div className="relative max-w-[85%] sm:max-w-[75%] rounded-3xl rounded-bl-md bg-white border border-slate-200 px-5 py-4 shadow-[0_8px_30px_-12px_rgba(15,23,42,0.18)]">
            <p className="text-slate-800 text-base md:text-lg leading-relaxed" data-testid="review-bubble-1">Employees can practise difficult conversations with Pitch Craft AI endlessly — without needing a manager, trainer, or real customer.</p>
          </div>
        </motion.div>
        <motion.div {...bubbleIn(0.25)} className="flex items-end gap-3">
          <div className="w-10 shrink-0" />
          <div className="relative max-w-[85%] sm:max-w-[75%] rounded-3xl rounded-bl-md bg-emerald-600 text-white px-5 py-4 shadow-[0_10px_30px_-10px_rgba(16,185,129,0.6)]">
            <p className="text-base md:text-lg leading-relaxed font-semibold" data-testid="review-bubble-2">For us, that is a massive selling point.</p>
          </div>
        </motion.div>
        <motion.div {...bubbleIn(0.45)} className="pl-14 text-xs text-slate-500 font-mono uppercase tracking-widest" data-testid="review-attribution">— Sales manager · Pitch Craft team customer</motion.div>
      </div>
    </section>
  );
}
